import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm shadow-sm py-4'}`} data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        <div className="flex justify-between items-center h-16" data-id="element-47">
          {/* Left Nav (Desktop) */}
          <nav className="hidden md:flex space-x-8 flex-1" data-id="element-48">
            <a href="#vendors" className="text-sm font-semibold text-brand-dark hover:text-brand-orange transition-colors uppercase tracking-wider" data-id="element-49">
              Our Vendors
            </a>
            <a href="#visit" className="text-sm font-semibold text-brand-dark hover:text-brand-orange transition-colors uppercase tracking-wider" data-id="element-50">
              Visit Us
            </a>
            <a href="#events" className="text-sm font-semibold text-brand-dark hover:text-brand-orange transition-colors uppercase tracking-wider" data-id="element-51">
              Private Events
            </a>
          </nav>

          {/* Logo */}
          <div className="flex-shrink-0 flex items-center justify-center flex-1 md:flex-none" data-id="element-52">
            <a href="#" className="relative group" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/gDgbccVMWUGsG3H9edJqHs/logo.png" alt="Market on 8th" className="w-16 h-16 object-contain group-hover:scale-105 transition-transform" data-id="element-54" />
            </a>
          </div>

          {/* Right Nav (Desktop) */}
          <nav className="hidden md:flex space-x-8 flex-1 justify-end items-center" data-id="element-55">
            <a href="#hours" className="text-sm font-semibold text-brand-dark hover:text-brand-orange transition-colors uppercase tracking-wider" data-id="element-56">
              Hours
            </a>
            <a href="https://www.instagram.com/marketon8thst/" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-brand-dark hover:text-brand-orange transition-colors uppercase tracking-wider" data-id="element-57">
              Instagram
            </a>
            <a href="https://maps.app.goo.gl/2Q6LZT6rFPQtYsny5" target="_blank" rel="noopener noreferrer" className="text-sm font-bold text-brand-orange hover:text-brand-coral transition-colors flex items-center gap-1 uppercase tracking-wider" data-id="element-58">
              Get Directions <span aria-hidden="true" data-id="element-59">&rarr;</span>
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-60">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-brand-dark hover:text-brand-orange p-2" data-id="element-61">
              {mobileMenuOpen ? <X size={24} data-id="element-62" /> : <Menu size={24} data-id="element-63" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 shadow-lg absolute top-full left-0 w-full" data-id="element-64">
          <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-65">
            <a href="#vendors" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-brand-dark hover:bg-brand-cream rounded-md" data-id="element-66">
              Our Vendors
            </a>
            <a href="#visit" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-brand-dark hover:bg-brand-cream rounded-md" data-id="element-67">
              Visit Us
            </a>
            <a href="#events" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-brand-dark hover:bg-brand-cream rounded-md" data-id="element-68">
              Private Events
            </a>
            <a href="#hours" onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-semibold text-brand-dark hover:bg-brand-cream rounded-md" data-id="element-69">
              Hours
            </a>
            <a href="https://www.instagram.com/marketon8thst/" target="_blank" rel="noopener noreferrer" className="block px-3 py-3 text-base font-semibold text-brand-dark hover:bg-brand-cream rounded-md" data-id="element-70">
              Instagram
            </a>
            <a href="https://maps.app.goo.gl/2Q6LZT6rFPQtYsny5" target="_blank" rel="noopener noreferrer" className="block px-3 py-3 text-base font-bold text-brand-orange hover:bg-brand-cream rounded-md" data-id="element-71">
              Get Directions &rarr;
            </a>
          </div>
        </div>}
    </header>;
}